import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { useMediaQuery } from "../mantine-passthroughs/index.js";

//#region src/hooks/layout/use-is-mobile.ts
const useIsMobile = (breakpoint = "sm") => {
	return useMediaQuery(`(max-width: calc(${useTheme().breakpoints[breakpoint]} - 1px))`);
};

//#endregion
export { useIsMobile };